import {
  AppBar,
  Avatar,
  Box,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  List,
  ListItem,
  Divider,
  Typography,
} from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { KeyboardArrowDown as KeyboardArrowDownIcon, Menu as MenuIcon } from "@material-ui/icons";
import React, { useState } from "react";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
// logo
import { Trans } from "@lingui/macro";
import LogoIcon from "../../containers/icons/logo-icon";
// theme
import Notifications from "../../containers/navbar/notifications";
import Link from "../link";
import LocaleSelector from "../../containers/locale-selector";
import { useNavigate } from "../../hooks/navigation";
import ExpiredSession from "../../containers/expired-session";

const useStyles = makeStyles((theme) => ({
  appbar: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    height: "84px",
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    boxShadow: "none",
    borderBottom: `3px solid ${theme.palette.primary.main}`,
    transition: "0.4s all ease-in",
    [theme.breakpoints.down("xs")]: {
      height: "60px",
    },
  },
  menu: {
    marginTop: 50,
    "& li": {
      color: theme.palette.gray71,
    },
  },
  logo: {
    height: 55,
    width: "auto",
    cursor: "pointer",
    [theme.breakpoints.down("xs")]: {
      height: "45px",
    },
  },
  navbarName: {
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
  },
  notifAndAvatar: {
    display: ({ isAuthenticated }) => (isAuthenticated ? "flex" : "none"),
    flex: 1,
    justifyContent: "flex-end",
    alignItems: "center",
    [theme.breakpoints.up("md")]: {
      flex: 5,
    },
  },
  links: {
    cursor: "pointer",
    color: theme.palette.primary.main,
  },
  userManual: {
    cursor: "pointer",
    "&:hover": {
      color: theme.palette.primary.main,
    },
    "&:visited": {
      color: "#333333",
      "&:hover": {
        color: theme.palette.primary.main,
      },
    },
    textDecoration: "none",
    fontFamily: "Nunito Sans",
    fontWeight: 400,
    lineHeight: 1.2,
    letterSpacing: "0.0075em",
  },
  avatarButton: {
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0)",
    },
  },
}));

export default function CustomNavbar({ user = {}, isAuthenticated, logout = () => {}, showFaqs }) {
  const { navigate } = useNavigate();
  // this should be the new way to get the theme
  const theme = useTheme();
  const notifications = user.notifications || [];
  const { isAdmin } = user;
  const classes = useStyles({
    ...theme,
    notifications,
    isAdmin,
    isAuthenticated,
  });

  const [anchorEl, setAnchorEl] = React.useState(null);

  const isMenuOpen = Boolean(anchorEl);

  const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);

  const handleMenuClose = () => setAnchorEl(null);

  const handleLogout = () => {
    handleMenuClose();
    logout();
  };

  const [isOpen, setIsOpen] = useState(false);
  const md = useMediaQuery("(max-width:600px)");

  return (
    <>
      <AppBar position="sticky" className={classes.appbar} color={isAdmin ? "primary" : "inherit"}>
        <SwipeableDrawer
          anchor="left"
          open={isOpen}
          onOpen={() => {}}
          onClose={() => {
            setIsOpen(false);
          }}
        >
          <Box width="70vw">
            <Box mt={2} width="100%" display="flex" flexDirection="row" justifyContent="center">
              <Link to="/">
                <LogoIcon className={classes.logo} darkMode={!(isAdmin && isAuthenticated)} />
              </Link>
            </Box>
            <List>
              {isAuthenticated ? (
                <ListItem>
                  <Avatar src={user.avatar} style={{ border: "1px solid black" }} />
                </ListItem>
              ) : (
                <Box width="40px" height="40px" />
              )}
              <ListItem>
                <Typography>{user.name}</Typography>
              </ListItem>
              <Divider />
              <ListItem
                button
                onClick={() => {
                  navigate("/");
                  setIsOpen(false);
                }}
              >
                Home
              </ListItem>
              <Divider />

              {!isAuthenticated && (
                <>
                  <Link to="/signin/">
                    <ListItem
                      button
                      onClick={() => {
                        setIsOpen(false);
                      }}
                    >
                      Login
                    </ListItem>
                  </Link>
                  <Divider />
                  <Link to="/signup/">
                    <ListItem
                      button
                      onClick={() => {
                        setIsOpen(false);
                      }}
                    >
                      Sign Up
                    </ListItem>
                  </Link>
                  <Divider />
                </>
              )}
              {isAuthenticated && !isAdmin && (
                <>
                  <ListItem
                    onClick={() => {
                      handleMenuClose();
                      setIsOpen(false);
                      navigate("/tenant");
                    }}
                  >
                    <Trans>Mis consultas</Trans>
                  </ListItem>
                  <Divider />
                  <ListItem
                    onClick={() => {
                      handleMenuClose();
                      setIsOpen(false);
                      navigate("/profile/");
                    }}
                  >
                    <Trans>Perfil</Trans>
                  </ListItem>
                  {showFaqs && (
                    <ListItem
                      onClick={() => {
                        handleMenuClose();
                        setIsOpen(false);
                        navigate("/faqs/");
                      }}
                    >
                      <Trans>Faqs</Trans>
                    </ListItem>
                  )}
                </>
              )}
              {isAuthenticated && isAdmin && (
                <>
                  <ListItem>
                    <Trans>Subir espacio</Trans>
                  </ListItem>
                  <Divider />
                  <ListItem>
                    <Trans>Mis espacios</Trans>
                  </ListItem>
                  <Divider />
                  <ListItem>
                    <Trans>Consultas</Trans>
                  </ListItem>
                  <Divider />
                  <ListItem
                    onClick={() => {
                      handleMenuClose();
                      setIsOpen(false);
                      navigate("/profile/");
                    }}
                  >
                    <Trans>Perfil</Trans>
                  </ListItem>

                  {showFaqs && (
                    <>
                      <Divider />
                      <ListItem
                        onClick={() => {
                          handleMenuClose();
                          setIsOpen(false);
                          navigate("/faqs/");
                        }}
                      >
                        <Trans>Faqs</Trans>
                      </ListItem>
                    </>
                  )}
                </>
              )}
              {isAuthenticated && (
                <>
                  <Divider />
                  <ListItem
                    onClick={() => {
                      handleLogout();
                      setIsOpen(false);
                    }}
                  >
                    <Trans>Salir</Trans>
                  </ListItem>
                </>
              )}
              <ListItem>
                <LocaleSelector isAuthenticated={isAuthenticated} />
              </ListItem>
              <Divider />
            </List>
          </Box>
        </SwipeableDrawer>
        <Grid container direction="row">
          <Grid item xs={3}>
            <Box display="flex" flexDirection="row" height="100%" alignItems="center">
              {!md && (
                <Link to="/">
                  <LogoIcon className={classes.logo} darkMode={!(isAdmin && isAuthenticated)} />
                </Link>
              )}
              {md && (
                <Box
                  onClick={() => {
                    setIsOpen(true);
                  }}
                >
                  <IconButton edge="start" className={classes.menuButton} color="inherit">
                    <MenuIcon />
                  </IconButton>
                </Box>
              )}
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box height="100%" display="flex" flexDirection="row" alignItems="center">
              {md && (
                <Box display="flex" flexDirection="row" justifyContent="center" alignItems="center" width="100%">
                  <LogoIcon
                    className={classes.logo}
                    darkMode={!(isAdmin && isAuthenticated)}
                    onClick={() => {
                      navigate("/");
                    }}
                  />
                </Box>
              )}
            </Box>
          </Grid>
          <Grid item xs={3}>
            {md && isAuthenticated && (
              <Box display="flex" height="100%" flexDirection="row" alignItems="center" justifyContent="flex-end">
                <Notifications />
              </Box>
            )}
            {!md && (
              <Box display="flex" height="100%" flexDirection="row" alignItems="center" justifyContent="flex-end">
                <LocaleSelector isAuthenticated={isAuthenticated} />
                {!isAuthenticated && (
                  <>
                    <Link className={classes.links} to="/signin/">
                      <Typography variant="h6">
                        <Trans>Login</Trans>
                      </Typography>
                    </Link>
                    <Link style={{ marginLeft: 10 }} className={classes.links} to="/signup/">
                      <Typography variant="h6">
                        <Trans>Sign Up</Trans>
                      </Typography>
                    </Link>
                  </>
                )}
                {isAuthenticated && (
                  <>
                    <Notifications />
                    <IconButton edge="end" onClick={handleMenuOpen} className={classes.avatarButton} color="inherit">
                      <Avatar src={user.avatar} style={{ border: "1px solid black" }} data-testid="navbar-avatar" />
                      <Typography variant="subtitle1" className={classes.navbarName}>
                        {user.name}
                      </Typography>
                      <KeyboardArrowDownIcon />
                    </IconButton>
                    <Menu
                      anchorEl={anchorEl}
                      id="user-menu"
                      open={isMenuOpen}
                      onClose={handleMenuClose}
                      className={classes.menu}
                      disableScrollLock
                    >
                      {!isAdmin && (
                        <Box>
                          <Link to="/tenant">
                            <MenuItem onClick={handleMenuClose}>
                              <Trans>Mis consultas</Trans>
                            </MenuItem>
                          </Link>
                          <Link to="/profile/">
                            <MenuItem onClick={handleMenuClose}>
                              <Trans>Perfil</Trans>
                            </MenuItem>
                          </Link>
                          {showFaqs && (
                            <Link to="/faqs/">
                              <MenuItem onClick={handleMenuClose}>
                                <Trans>Faqs</Trans>
                              </MenuItem>
                            </Link>
                          )}
                        </Box>
                      )}
                      {isAdmin && (
                        <Box>
                          <Link to="/administrator/home">
                            <MenuItem onClick={handleMenuClose}>
                              <Trans>Dashboard</Trans>
                            </MenuItem>
                          </Link>
                          <Link to="/administrator/spaces/">
                            <MenuItem onClick={handleMenuClose}>
                              <Trans>Espacios</Trans>
                            </MenuItem>
                          </Link>
                          <Link to="/administrator/requests">
                            <MenuItem onClick={handleMenuClose}>
                              <Trans>Consultas</Trans>
                            </MenuItem>
                          </Link>
                          <Link to="/profile/">
                            <MenuItem onClick={handleMenuClose}>
                              <Trans>Perfil</Trans>
                            </MenuItem>
                          </Link>
                          {showFaqs && (
                            <Link to="/faqs/">
                              <MenuItem onClick={handleMenuClose}>
                                <Trans>Faqs</Trans>
                              </MenuItem>
                            </Link>
                          )}
                        </Box>
                      )}
                      <MenuItem
                        onClick={() => {
                          handleLogout();
                        }}
                      >
                        <Trans>Salir</Trans>
                      </MenuItem>
                    </Menu>
                  </>
                )}
              </Box>
            )}
          </Grid>
        </Grid>
      </AppBar>
      <ExpiredSession />
    </>
  );
}
